<template>
    <div class="notice-release app-main">
        <el-row type="flex" class="app-main-header" align="middle">
            <el-col :span="6">
                <div class="router-title">
                    <i class="el-icon-s-home"></i><span style="margin-left: 5px;">{{$route.meta.title}}</span>
                </div>
            </el-col>
            <el-col :span="18" class="app-main-header-btns">
                <el-button size="small" type="primary" @click="handleAdd" >新增 </el-button>
            </el-col>
        </el-row>
        <el-row class="mg-b5">
            <el-card class="box-card" v-loading="loading">
                <div slot="header" class="clearfix">
                    <el-form :inline="true" class="demo-form-inline">
                        <!-- <el-form-item class="my-form-item">
                            <el-date-picker size="mini" :unlink-panels="true" type="daterange" range-separator="-"
                                v-model="quertInfo.searchTime" start-placeholder="开始日期"
                                value-format="yyyy-MM-dd"
                                style="width: 200px"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item> -->
                        <el-form-item  class="my-form-item">
                            <el-select size="mini" v-model="quertInfo.objMap.noticeType" clearable  style="width: 100%" placeholder="请选择公告类型">
                                <el-option v-for="item in noticeType" :key="item.code" :label="item.name" :value="item.code"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="my-form-item">
                            <el-input size="mini" placeholder="请输入查询条件" clearable v-model="quertInfo.objMap.search"
                                        style="width: 160px"
                                        prefix-icon="el-icon-search"></el-input>
                        </el-form-item>
                        <el-form-item class="my-form-item">
                            <el-button size="mini" type="primary" @click="onSearch" >查询 </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                 <el-table :data="tableData" border size="mini" :header-cell-style="headerCellStyle" :height="PAGESIZE.h-210" @selection-change="handleSelectionChange">
                     <el-table-column prop="title" label="公告标题" :show-overflow-tooltip="true"></el-table-column>
                     <el-table-column prop="noticeType" label="公告类型" :formatter="formatType"></el-table-column>
                     <el-table-column prop="createTime" label="发布时间" :show-overflow-tooltip="true"></el-table-column>
                     <el-table-column prop="a4" label="发布状态">
                         <template slot-scope="scope">
                             <span v-if="scope.row.status == 0">未发布</span>
                             <span v-if="scope.row.status == 1">已发布</span>
                        </template>
                     </el-table-column>
                     <el-table-column label="操作" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" :disabled="scope.row.status == 1" @click="handleEdit(scope.row)">修改 </el-button>
                            <el-button type="text" size="small" :disabled="scope.row.status == 1" @click="handleDel(scope.row)">删除 </el-button>
                            <el-button type="text" size="small" @click="showInfo(scope.row)">预览 </el-button>
                            <el-button type="text" size="small" v-if="scope.row.status == 0" @click="editStatus(scope.row,1)">发布 </el-button>
                            <el-button type="text" size="small" v-if="scope.row.status == 1" @click="editStatus(scope.row,0)">取消发布 </el-button>
                        </template>
                     </el-table-column>
                </el-table>
                 <el-row type="flex" justify="end" class="mg-t5">
                    <pagination v-show="count>0" @on-pagination="onPagination" :page.sync="quertInfo.page"
                                :limit.sync="quertInfo.limit"
                                :total="count">
                    </pagination>
                </el-row>
            </el-card>
        </el-row>
         <EditDialog ref="EditDialogRef" @callback="EditDialogCallback"/>
    </div>
</template>

<script>
import EditDialog from './EditDialog.vue'
import { getNoticeList, delNotice, noticeById,editNotice} from '../../../api/notice'
import { noticeType } from '../../../utils/dict'
export default {
    components:{
        EditDialog
    },
    data() {
        return {
            noticeType,
            loading:false,
            quertInfo: {
                page: 1, //当前页码
                limit: 20, //当前每页显示的数量
                searchTime: [],
                objMap: {
                    search: '',
                    status:'',
                    noticeType:'',
                }
            },
            count:20,
            tableData:[],
        };
    },
    computed: {
        PAGESIZE:function(){
            return this.$store.getters['app/sizeInfo'];
        },
    },
    created() {

    },
    mounted() {
        this.getList();
    },
    methods: {
        onSearch(){
            this.quertInfo.page = 1;
            this.getList();
        },
        async getList(){
            let _this = this;
            _this.loading = true;
            const {
                data: res
            } = await getNoticeList(_this.quertInfo)
            _this.loading = false;
            if (res.code == 0) {
                _this.tableData = res.data;
                _this.count = res.count;
            }
        },
        onPagination: function (val) {
            this.quertInfo.page = val.page;
            this.quertInfo.limit = val.limit;
            this.getList();
        },
        handleAdd(){
            this.$refs.EditDialogRef.openDialogFun(null,'新增公告')
        },
        handleSelectionChange(){

        },
        handleEdit(row){
            noticeById({id:row.id}).then(({data:res})=>{
                if(res.code == 0){
                    console.log(res)
                    this.$refs.EditDialogRef.openDialogFun(res.data,'编辑公告')
                }
            })
        },
        showInfo(row){
            let origin = window.location.origin+window.location.pathname;
            console.log(`${origin}/noticeinfo/${row.id}`)
            window.open(`/noticeinfo/${row.id}`)
            // window.open(`${origin}/noticeinfo/${row.id}`)
            // localStorage.setItem('PAGENO',this.pageNo)
            // this.$router.push({path:`/${this.rootKey}/newsinfo/${this.type}/${obj.data.id}`});
        },
        handleDel(row){
            let _this = this;
            _this.confirm({
                text: '确认删除吗',
                tip: '警告',
                type: '',
                fn: function(param) {
                    delNotice(param).then(response => {
                        if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.getList();
                        } else {
                            _this.$fail(response.data.msg);
                        }
                    });
                },
                data: {
                    id: row.id
                } //参数对象 主要回调函数用
            });
        },
        editStatus(row,type){
            let _this = this;
            editNotice({id:row.id,status:type}).then(response => {
                if (response.data.code === 0) {
                    _this.$success('操作成功');
                    _this.getList();
                } else {
                    _this.$fail(response.data.msg);
                }
            });
        },
        EditDialogCallback(obj){
            if(obj.type == 'getlist'){
                this.getList()
            }
        },
        formatType: function (row) {
            let text = ''
            noticeType.forEach((item)=>{
                if(item.code == row.noticeType){
                    text = item.name
                }
            })
            return text;
        },
    },
    watch: {

    },

};
</script>

<style scoped lang="scss">

</style>
